import React, { useCallback, useEffect, useMemo, useState } from "react";
import _, { get } from "lodash";
import { BiSolidDownArrow, BiSolidUpArrow } from "react-icons/bi";
import Pagination from "../../../components/pagination/Pagination";
import EyesIcon from "../../../assets/icons/EyesIcon";
import { Download } from "../../../assets/icons/Download";
import { Selector } from "../../../components/selector/Selector";
import MonyBadge from "../../../assets/icons/MonyBadge";
import Dollar from "../../../assets/icons/Dollar";
import { useAuth } from "../../../hooks/useAuth";
import { capitalized } from "../../../utils";
import { useTranslation } from "react-i18next";
import { PaymentTable } from "../register/components/UserDetails";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PaymentReceipt from "../../../features/Pdfs/PaymentReceipt";
import AccountStatement from "../../../features/Pdfs/AccountStatement";
import { getPaymentReceipts } from "../../../services/UsersService";

const Card = ({
  title,
  description,
  payment = false,
  onDownload,
  name,
  label,
  user,
  landsToOptions,
  options,
  selectedLand,
  type = "lands",
  lands,
}) => {
  const [month, setMonth] = useState(undefined);
  const [land, setLand] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [paymentReceipts, setPaymentReceipts] = useState([]);

  useEffect(() => {
    if (land?.id || month?.value) {
      getPaymentReceipts({
        month: month?.value,
        landId: land?.id,
      }).then((res) => {
        //TODO: data pdf
        setPaymentReceipts(res?.data?.data?.[0]?.lands);
      });
    }
  }, [land?.id, month?.value]);


  const dataLands = [
    {
      landId: 574,
      lands: [
        {
          id: 241,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 1,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-02-10 00:27:35",
          balance: 40000,
          status: "PAID",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-02-10 00:27:35",
          remainingAmount: 40000,
          concept: 1,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 242,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 2,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-03-10 00:27:35",
          balance: 39666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-03-10 00:27:35",
          remainingAmount: 39666.67,
          concept: 2,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 243,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 3,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-04-10 00:27:35",
          balance: 39333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-04-10 00:27:35",
          remainingAmount: 39333.33,
          concept: 3,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 244,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 4,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-05-10 00:27:35",
          balance: 39000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-05-10 00:27:35",
          remainingAmount: 39000,
          concept: 4,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 245,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 5,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-06-10 00:27:35",
          balance: 38666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-06-10 00:27:35",
          remainingAmount: 38666.67,
          concept: 5,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 246,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 6,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-07-10 00:27:35",
          balance: 38333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-07-10 00:27:35",
          remainingAmount: 38333.33,
          concept: 6,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 247,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 7,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-08-10 00:27:35",
          balance: 38000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-08-10 00:27:35",
          remainingAmount: 38000,
          concept: 7,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 248,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 8,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-09-10 00:27:35",
          balance: 37666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-09-10 00:27:35",
          remainingAmount: 37666.67,
          concept: 8,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 249,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 9,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-10-10 00:27:35",
          balance: 37333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-10-10 00:27:35",
          remainingAmount: 37333.33,
          concept: 9,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 250,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 10,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-11-10 00:27:35",
          balance: 37000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-11-10 00:27:35",
          remainingAmount: 37000,
          concept: 10,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 251,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 11,
          amount: 333.33,
          interest: 0,
          payment_date: "2025-12-10 00:27:35",
          balance: 36666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2025-12-10 00:27:35",
          remainingAmount: 36666.67,
          concept: 11,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 252,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 12,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-01-10 00:27:35",
          balance: 36333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-01-10 00:27:35",
          remainingAmount: 36333.33,
          concept: 12,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 253,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 13,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-02-10 00:27:35",
          balance: 36000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-02-10 00:27:35",
          remainingAmount: 36000,
          concept: 13,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 254,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 14,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-03-10 00:27:35",
          balance: 35666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-03-10 00:27:35",
          remainingAmount: 35666.67,
          concept: 14,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 255,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 15,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-04-10 00:27:35",
          balance: 35333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-04-10 00:27:35",
          remainingAmount: 35333.33,
          concept: 15,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 256,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 16,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-05-10 00:27:35",
          balance: 35000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-05-10 00:27:35",
          remainingAmount: 35000,
          concept: 16,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 257,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 17,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-06-10 00:27:35",
          balance: 34666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-06-10 00:27:35",
          remainingAmount: 34666.67,
          concept: 17,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 258,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 18,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-07-10 00:27:35",
          balance: 34333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-07-10 00:27:35",
          remainingAmount: 34333.33,
          concept: 18,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 259,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 19,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-08-10 00:27:35",
          balance: 34000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-08-10 00:27:35",
          remainingAmount: 34000,
          concept: 19,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 260,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 20,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-09-10 00:27:35",
          balance: 33666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-09-10 00:27:35",
          remainingAmount: 33666.67,
          concept: 20,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 261,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 21,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-10-10 00:27:35",
          balance: 33333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-10-10 00:27:35",
          remainingAmount: 33333.33,
          concept: 21,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 262,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 22,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-11-10 00:27:35",
          balance: 33000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-11-10 00:27:35",
          remainingAmount: 33000,
          concept: 22,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 263,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 23,
          amount: 333.33,
          interest: 0,
          payment_date: "2026-12-10 00:27:35",
          balance: 32666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2026-12-10 00:27:35",
          remainingAmount: 32666.67,
          concept: 23,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 264,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 24,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-01-10 00:27:35",
          balance: 32333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-01-10 00:27:35",
          remainingAmount: 32333.33,
          concept: 24,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 265,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 25,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-02-10 00:27:35",
          balance: 32000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-02-10 00:27:35",
          remainingAmount: 32000,
          concept: 25,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 266,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 26,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-03-10 00:27:35",
          balance: 31666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-03-10 00:27:35",
          remainingAmount: 31666.67,
          concept: 26,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 267,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 27,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-04-10 00:27:35",
          balance: 31333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-04-10 00:27:35",
          remainingAmount: 31333.33,
          concept: 27,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 268,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 28,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-05-10 00:27:35",
          balance: 31000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-05-10 00:27:35",
          remainingAmount: 31000,
          concept: 28,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 269,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 29,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-06-10 00:27:35",
          balance: 30666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-06-10 00:27:35",
          remainingAmount: 30666.67,
          concept: 29,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 270,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 30,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-07-10 00:27:35",
          balance: 30333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-07-10 00:27:35",
          remainingAmount: 30333.33,
          concept: 30,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 271,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 31,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-08-10 00:27:35",
          balance: 30000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-08-10 00:27:35",
          remainingAmount: 30000,
          concept: 31,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 272,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 32,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-09-10 00:27:35",
          balance: 29666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-09-10 00:27:35",
          remainingAmount: 29666.67,
          concept: 32,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 273,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 33,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-10-10 00:27:35",
          balance: 29333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-10-10 00:27:35",
          remainingAmount: 29333.33,
          concept: 33,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 274,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 34,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-11-10 00:27:35",
          balance: 29000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-11-10 00:27:35",
          remainingAmount: 29000,
          concept: 34,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 275,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 35,
          amount: 333.33,
          interest: 0,
          payment_date: "2027-12-10 00:27:35",
          balance: 28666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2027-12-10 00:27:35",
          remainingAmount: 28666.67,
          concept: 35,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 276,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 36,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-01-10 00:27:35",
          balance: 28333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-01-10 00:27:35",
          remainingAmount: 28333.33,
          concept: 36,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 277,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 37,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-02-10 00:27:35",
          balance: 28000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-02-10 00:27:35",
          remainingAmount: 28000,
          concept: 37,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 278,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 38,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-03-10 00:27:35",
          balance: 27666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-03-10 00:27:35",
          remainingAmount: 27666.67,
          concept: 38,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 279,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 39,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-04-10 00:27:35",
          balance: 27333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-04-10 00:27:35",
          remainingAmount: 27333.33,
          concept: 39,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 280,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 40,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-05-10 00:27:35",
          balance: 27000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-05-10 00:27:35",
          remainingAmount: 27000,
          concept: 40,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 281,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 41,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-06-10 00:27:35",
          balance: 26666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-06-10 00:27:35",
          remainingAmount: 26666.67,
          concept: 41,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 282,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 42,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-07-10 00:27:35",
          balance: 26333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-07-10 00:27:35",
          remainingAmount: 26333.33,
          concept: 42,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 283,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 43,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-08-10 00:27:35",
          balance: 26000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-08-10 00:27:35",
          remainingAmount: 26000,
          concept: 43,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 284,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 44,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-09-10 00:27:35",
          balance: 25666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-09-10 00:27:35",
          remainingAmount: 25666.67,
          concept: 44,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 285,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 45,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-10-10 00:27:35",
          balance: 25333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-10-10 00:27:35",
          remainingAmount: 25333.33,
          concept: 45,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 286,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 46,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-11-10 00:27:35",
          balance: 25000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-11-10 00:27:35",
          remainingAmount: 25000,
          concept: 46,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 287,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 47,
          amount: 333.33,
          interest: 0,
          payment_date: "2028-12-10 00:27:35",
          balance: 24666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2028-12-10 00:27:35",
          remainingAmount: 24666.67,
          concept: 47,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 288,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 48,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-01-10 00:27:35",
          balance: 24333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-01-10 00:27:35",
          remainingAmount: 24333.33,
          concept: 48,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 289,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 49,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-02-10 00:27:35",
          balance: 24000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-02-10 00:27:35",
          remainingAmount: 24000,
          concept: 49,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 290,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 50,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-03-10 00:27:35",
          balance: 23666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-03-10 00:27:35",
          remainingAmount: 23666.67,
          concept: 50,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 291,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 51,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-04-10 00:27:35",
          balance: 23333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-04-10 00:27:35",
          remainingAmount: 23333.33,
          concept: 51,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 292,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 52,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-05-10 00:27:35",
          balance: 23000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-05-10 00:27:35",
          remainingAmount: 23000,
          concept: 52,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 293,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 53,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-06-10 00:27:35",
          balance: 22666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-06-10 00:27:35",
          remainingAmount: 22666.67,
          concept: 53,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 294,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 54,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-07-10 00:27:35",
          balance: 22333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-07-10 00:27:35",
          remainingAmount: 22333.33,
          concept: 54,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 295,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 55,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-08-10 00:27:35",
          balance: 22000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-08-10 00:27:35",
          remainingAmount: 22000,
          concept: 55,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 296,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 56,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-09-10 00:27:35",
          balance: 21666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-09-10 00:27:35",
          remainingAmount: 21666.67,
          concept: 56,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 297,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 57,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-10-10 00:27:35",
          balance: 21333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-10-10 00:27:35",
          remainingAmount: 21333.33,
          concept: 57,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 298,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 58,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-11-10 00:27:35",
          balance: 21000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-11-10 00:27:35",
          remainingAmount: 21000,
          concept: 58,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 299,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 59,
          amount: 333.33,
          interest: 0,
          payment_date: "2029-12-10 00:27:35",
          balance: 20666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2029-12-10 00:27:35",
          remainingAmount: 20666.67,
          concept: 59,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 300,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 60,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-01-10 00:27:35",
          balance: 20333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-01-10 00:27:35",
          remainingAmount: 20333.33,
          concept: 60,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 301,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 61,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-02-10 00:27:35",
          balance: 20000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-02-10 00:27:35",
          remainingAmount: 20000,
          concept: 61,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 302,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 62,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-03-10 00:27:35",
          balance: 19666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-03-10 00:27:35",
          remainingAmount: 19666.67,
          concept: 62,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 303,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 63,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-04-10 00:27:35",
          balance: 19333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-04-10 00:27:35",
          remainingAmount: 19333.33,
          concept: 63,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 304,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 64,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-05-10 00:27:35",
          balance: 19000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-05-10 00:27:35",
          remainingAmount: 19000,
          concept: 64,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 305,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 65,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-06-10 00:27:35",
          balance: 18666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-06-10 00:27:35",
          remainingAmount: 18666.67,
          concept: 65,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 306,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 66,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-07-10 00:27:35",
          balance: 18333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-07-10 00:27:35",
          remainingAmount: 18333.33,
          concept: 66,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 307,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 67,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-08-10 00:27:35",
          balance: 18000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-08-10 00:27:35",
          remainingAmount: 18000,
          concept: 67,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 308,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 68,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-09-10 00:27:35",
          balance: 17666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-09-10 00:27:35",
          remainingAmount: 17666.67,
          concept: 68,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 309,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 69,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-10-10 00:27:35",
          balance: 17333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-10-10 00:27:35",
          remainingAmount: 17333.33,
          concept: 69,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 310,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 70,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-11-10 00:27:35",
          balance: 17000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-11-10 00:27:35",
          remainingAmount: 17000,
          concept: 70,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 311,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 71,
          amount: 333.33,
          interest: 0,
          payment_date: "2030-12-10 00:27:35",
          balance: 16666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2030-12-10 00:27:35",
          remainingAmount: 16666.67,
          concept: 71,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 312,
          created_at: "2025-01-10T06:27:35.000000Z",
          updated_at: "2025-01-10T06:27:35.000000Z",
          land_id: 574,
          client_id: 37,
          period: 72,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-01-10 00:27:35",
          balance: 16333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-01-10 00:27:35",
          remainingAmount: 16333.33,
          concept: 72,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 313,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 73,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-02-10 00:27:35",
          balance: 16000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-02-10 00:27:35",
          remainingAmount: 16000,
          concept: 73,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 314,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 74,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-03-10 00:27:35",
          balance: 15666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-03-10 00:27:35",
          remainingAmount: 15666.67,
          concept: 74,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 315,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 75,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-04-10 00:27:35",
          balance: 15333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-04-10 00:27:35",
          remainingAmount: 15333.33,
          concept: 75,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 316,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 76,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-05-10 00:27:35",
          balance: 15000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-05-10 00:27:35",
          remainingAmount: 15000,
          concept: 76,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 317,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 77,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-06-10 00:27:35",
          balance: 14666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-06-10 00:27:35",
          remainingAmount: 14666.67,
          concept: 77,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 318,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 78,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-07-10 00:27:35",
          balance: 14333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-07-10 00:27:35",
          remainingAmount: 14333.33,
          concept: 78,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 319,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 79,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-08-10 00:27:35",
          balance: 14000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-08-10 00:27:35",
          remainingAmount: 14000,
          concept: 79,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 320,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 80,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-09-10 00:27:35",
          balance: 13666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-09-10 00:27:35",
          remainingAmount: 13666.67,
          concept: 80,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 321,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 81,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-10-10 00:27:35",
          balance: 13333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-10-10 00:27:35",
          remainingAmount: 13333.33,
          concept: 81,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 322,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 82,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-11-10 00:27:35",
          balance: 13000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-11-10 00:27:35",
          remainingAmount: 13000,
          concept: 82,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 323,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 83,
          amount: 333.33,
          interest: 0,
          payment_date: "2031-12-10 00:27:35",
          balance: 12666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2031-12-10 00:27:35",
          remainingAmount: 12666.67,
          concept: 83,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 324,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 84,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-01-10 00:27:35",
          balance: 12333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-01-10 00:27:35",
          remainingAmount: 12333.33,
          concept: 84,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 325,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 85,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-02-10 00:27:35",
          balance: 12000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-02-10 00:27:35",
          remainingAmount: 12000,
          concept: 85,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 326,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 86,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-03-10 00:27:35",
          balance: 11666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-03-10 00:27:35",
          remainingAmount: 11666.67,
          concept: 86,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 327,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 87,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-04-10 00:27:35",
          balance: 11333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-04-10 00:27:35",
          remainingAmount: 11333.33,
          concept: 87,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 328,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 88,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-05-10 00:27:35",
          balance: 11000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-05-10 00:27:35",
          remainingAmount: 11000,
          concept: 88,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 329,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 89,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-06-10 00:27:35",
          balance: 10666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-06-10 00:27:35",
          remainingAmount: 10666.67,
          concept: 89,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 330,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 90,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-07-10 00:27:35",
          balance: 10333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-07-10 00:27:35",
          remainingAmount: 10333.33,
          concept: 90,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 331,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 91,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-08-10 00:27:35",
          balance: 10000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-08-10 00:27:35",
          remainingAmount: 10000,
          concept: 91,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 332,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 92,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-09-10 00:27:35",
          balance: 9666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-09-10 00:27:35",
          remainingAmount: 9666.67,
          concept: 92,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 333,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 93,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-10-10 00:27:35",
          balance: 9333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-10-10 00:27:35",
          remainingAmount: 9333.33,
          concept: 93,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 334,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 94,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-11-10 00:27:35",
          balance: 9000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-11-10 00:27:35",
          remainingAmount: 9000,
          concept: 94,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 335,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 95,
          amount: 333.33,
          interest: 0,
          payment_date: "2032-12-10 00:27:35",
          balance: 8666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2032-12-10 00:27:35",
          remainingAmount: 8666.67,
          concept: 95,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 336,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 96,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-01-10 00:27:35",
          balance: 8333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-01-10 00:27:35",
          remainingAmount: 8333.33,
          concept: 96,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 337,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 97,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-02-10 00:27:35",
          balance: 8000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-02-10 00:27:35",
          remainingAmount: 8000,
          concept: 97,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 338,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 98,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-03-10 00:27:35",
          balance: 7666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-03-10 00:27:35",
          remainingAmount: 7666.67,
          concept: 98,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 339,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 99,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-04-10 00:27:35",
          balance: 7333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-04-10 00:27:35",
          remainingAmount: 7333.33,
          concept: 99,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 340,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 100,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-05-10 00:27:35",
          balance: 7000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-05-10 00:27:35",
          remainingAmount: 7000,
          concept: 100,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 341,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 101,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-06-10 00:27:35",
          balance: 6666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-06-10 00:27:35",
          remainingAmount: 6666.67,
          concept: 101,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 342,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 102,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-07-10 00:27:35",
          balance: 6333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-07-10 00:27:35",
          remainingAmount: 6333.33,
          concept: 102,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 343,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 103,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-08-10 00:27:35",
          balance: 6000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-08-10 00:27:35",
          remainingAmount: 6000,
          concept: 103,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 344,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 104,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-09-10 00:27:35",
          balance: 5666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-09-10 00:27:35",
          remainingAmount: 5666.67,
          concept: 104,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 345,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 105,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-10-10 00:27:35",
          balance: 5333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-10-10 00:27:35",
          remainingAmount: 5333.33,
          concept: 105,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 346,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 106,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-11-10 00:27:35",
          balance: 5000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-11-10 00:27:35",
          remainingAmount: 5000,
          concept: 106,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 347,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 107,
          amount: 333.33,
          interest: 0,
          payment_date: "2033-12-10 00:27:35",
          balance: 4666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2033-12-10 00:27:35",
          remainingAmount: 4666.67,
          concept: 107,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 348,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 108,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-01-10 00:27:35",
          balance: 4333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-01-10 00:27:35",
          remainingAmount: 4333.33,
          concept: 108,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 349,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 109,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-02-10 00:27:35",
          balance: 4000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-02-10 00:27:35",
          remainingAmount: 4000,
          concept: 109,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 350,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 110,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-03-10 00:27:35",
          balance: 3666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-03-10 00:27:35",
          remainingAmount: 3666.67,
          concept: 110,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 351,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 111,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-04-10 00:27:35",
          balance: 3333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-04-10 00:27:35",
          remainingAmount: 3333.33,
          concept: 111,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 352,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 112,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-05-10 00:27:35",
          balance: 3000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-05-10 00:27:35",
          remainingAmount: 3000,
          concept: 112,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 353,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 113,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-06-10 00:27:35",
          balance: 2666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-06-10 00:27:35",
          remainingAmount: 2666.67,
          concept: 113,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 354,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 114,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-07-10 00:27:35",
          balance: 2333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-07-10 00:27:35",
          remainingAmount: 2333.33,
          concept: 114,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 355,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 115,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-08-10 00:27:35",
          balance: 2000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-08-10 00:27:35",
          remainingAmount: 2000,
          concept: 115,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 356,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 116,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-09-10 00:27:35",
          balance: 1666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-09-10 00:27:35",
          remainingAmount: 1666.67,
          concept: 116,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 357,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 117,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-10-10 00:27:35",
          balance: 1333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-10-10 00:27:35",
          remainingAmount: 1333.33,
          concept: 117,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 358,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 118,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-11-10 00:27:35",
          balance: 1000,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-11-10 00:27:35",
          remainingAmount: 1000,
          concept: 118,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 359,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 119,
          amount: 333.33,
          interest: 0,
          payment_date: "2034-12-10 00:27:35",
          balance: 666.67,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2034-12-10 00:27:35",
          remainingAmount: 666.67,
          concept: 119,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
        {
          id: 360,
          created_at: "2025-01-10T06:27:36.000000Z",
          updated_at: "2025-01-10T06:27:36.000000Z",
          land_id: 574,
          client_id: 37,
          period: 120,
          amount: 333.33,
          interest: 0,
          payment_date: "2035-01-10 00:27:35",
          balance: 333.33,
          status: "PENDING",
          payment_amount: 0,
          deleted_at: null,
          landId: 574,
          landName: "Mz37 Lt10",
          landPrice: 50000,
          manzana: "37",
          lote: "10",
          paymentDate: "2035-01-10 00:27:35",
          remainingAmount: 333.33,
          concept: 120,
          paymentMethod: "Transferencia bancaria",
          total: 25000000,
        },
      ],
    },
  ];


  const filteredPayments = dataLands.flatMap((land) =>
    land.lands.filter((payment, index, array) => {
      const paymentDate = new Date(payment.payment_date);
      const year = paymentDate.getFullYear();
      const month = paymentDate.getMonth();
  
      if (year === 2025) return true;
  
      if (year === 2026 && month === 0) {
        const previousPayment = array[index - 1];
        if (previousPayment) {
          const prevDate = new Date(previousPayment.payment_date);
          return prevDate.getFullYear() === 2025 && prevDate.getMonth() === 11;
        }
      }
  
      return false;
    })
  );

  return (
    <div className="bg-white rounded-md p-8 w-96">
      <div className="w-48 pb-8">
        {type === "lands" && (
          <Selector
            label=""
            name={name}
            options={(landsToOptions && landsToOptions()) || []}
            defaultValue={{
              value: 0,
              label: "Seleccione un terreno",
            }}
            isNewVersion
            onChange={(e) => {
              setLand(lands?.find((l) => l.id === e.value));
            }}
          />
        )}
        {type === "monts" && (
          <Selector
            label=""
            name={name}
            options={options}
            defaultValue={{
              value: 0,
              label: "Seleccione un mes",
            }}
            isNewVersion
            onChange={(e) => setMonth(e)}
          />
        )}
      </div>

      <div className="flex flex-row justify-between gap-6">
        <div>
          <label className="text-2xl font-demibold">{title}</label>
          <p className="text-md py-2 mt-3">{description}</p>
          <div className="hover:cursor-pointer">
            {month || land ? (
              <PDFDownloadLink
                document={
                  type === "lands" ? (
                    <AccountStatement
                      fullName={user?.name + " " + user?.last_name}
                      payment={filteredPayments}
                    />
                  ) : (
                    <PaymentReceipt
                      fullName={user?.name + " " + user?.last_name}
                      paymentDate={paymentReceipts?.[0]?.paymentDate || ""}
                      land={land}
                      landName={paymentReceipts?.[0]?.landName || user?.client?.lands?.[0]?.identifying_label}
                      amount={paymentReceipts?.[0]?.amount || "333.47"}
                      operationNumber={paymentReceipts?.[0]?.concept || "2"}
                      remainingAmount={
                        paymentReceipts?.[0]?.remainingAmount || "39666.67"
                      }
                    />
                  )
                }
                fileName="Informacion.pdf"
                className="label-details underline hover:cursor-pointer p-0"
                style={{
                  fontSize: "16px",
                  lineHeight: "0%",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                {({ loading: loadingPdf }) =>
                  loadingPdf || loading ? (
                    "loading..."
                  ) : (
                    <Download size={34} onClick={onDownload} />
                  )
                }
              </PDFDownloadLink>
            ) : (
              <Download color="gray" size={34} onClick={onDownload} />
            )}
          </div>
        </div>
        {payment ? <MonyBadge /> : <Dollar />}
      </div>
    </div>
  );
};

const UserDocuments = () => {
  const auth = useAuth();
  const { user } = auth.user;
  const { i18n } = useTranslation();

  const [selectedLand, setSelectedLand] = useState(null);

  const clientHasLands = useCallback(() => {
    return user?.client?.lands?.length > 0;
  }, [user?.client?.lands]);

  const landsToOptions = useCallback(() => {
    if (clientHasLands) {
      return user?.client?.lands?.map?.((l) => ({
        value: l?.id,
        label: l?.identifying_label,
      }));
    } else {
      return [];
    }
  }, [clientHasLands, user?.client?.lands]);

  const months = useMemo(() => {
    return Array.from({ length: 12 }, (_, index) => {
      const monthValue = index + 1;
      return {
        label: capitalized(
          new Date(2023, index, 1).toLocaleString(
            i18n.language === "es" ? i18n.language : "default",
            { month: "long" }
          )
        ),
        value: monthValue,
      };
    });
  }, [i18n?.language]);

  useEffect(()=> {
    if (user?.client?.lands?.length > 0) {
      setSelectedLand(user?.client?.lands?.[0]);
    }
  },[user?.client?.lands]);

  return (
    <div className="p-5 DashboardSeller max-w-screen-xl pr-10">
      <div className="flex flex-col lg:flex-row lg:justify-start items-center w-full mt-10 gap-6">
        <h3 className="title text-2xl">Pagos</h3>
      </div>
      <div className="w-full flex flex-col lg:flex-row justify-start gap-6 lg:gap-20 my-16">
        <Card
          title="Comprobante de pago"
          description="Conoce y descarga tu estado de pago"
          payment={true}
          name="month"
          label={{
            value: 0,
            label: "Mes",
          }}
          options={months}
          selectedLand={selectedLand}
          lands={user?.client?.lands || []}
          user={user}
          type="monts"
        />
        <Card
          title="Estado de cuenta"
          description="Conoce y descarga tu estado de cuenta"
          name="month"
          label="seleccione terreno"
          landsToOptions={landsToOptions}
          user={user}
          selectedLand={selectedLand}
          lands={user?.client?.lands || []}
        />
      </div>

      <div className="flex flex-col lg:flex-row justify-between">
        <p className="text-2 text-[#1E5F6B]">
          !Has completado 0 de 120 pagos!
        </p>
        <div className="w-52">
          <Selector
            label=""
            name={"month"}
            options={landsToOptions()}
            defaultValue={{
              value: user?.client?.lands[0]?.id || null,
              label: user?.client?.lands[0]?.identifying_label || "Seleccione terreno",
            }}
            isNewVersion
            onChange={({ value }) => {
              const land = user?.client?.lands?.find?.((l) => l?.id === value);
              setSelectedLand(land);
            }}
          />
        </div>
      </div>
      <div className="w-full">
        {/* Vista movil */}
        <div className="block lg:hidden">
          {_.map([{}, {}], (theUser, index) => (
            <div key={index} className="card-info">
              <div className="flex justify-between px-4">
                <div
                  className="text-sm text-black-50 hover-links"
                  onClick={() => {}}
                >
                  {theUser.name} {theUser.last_name}
                </div>
                <div>
                  {!theUser.show && <BiSolidDownArrow onClick={() => {}} />}
                  {theUser.show && <BiSolidUpArrow onClick={() => {}} />}
                </div>
              </div>
              {!theUser.show && (
                <div>
                  <div className="grid grid-cols-2 gap-4 my-2">
                    <div className="field-title text-black-50">Documentos</div>
                    <div className="text-left field-value text-black-50">
                      Lorem ipsum dolor sit amet
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 my-2">
                    <div className="field-title"></div>
                    <div className="text-left field-value text-black-50">
                      <EyesIcon size={20} />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 my-2">
                    <div className="field-title"></div>
                    <div className="text-left field-value text-black-50">
                      <Download size={20} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        {/* vista web */}
        <PaymentTable
          client={{ client: user?.client }}
          land={{
            value: selectedLand?.id,
          }}
          isLabelDownload={false}
        />

        {/* vista web */}
        {/*<div className="hidden lg:block overflow-hidden rounded-lg shadow-lg mt-5">
          <table className="w-full  table-auto">
            <thead className="text-black bg-header">
              <tr>
                <td className="p-2">ID</td>
                <td className="p-2">Cargo</td>
                <td className="p-2">Fecha de</td>
                <td className="p-2">Parcialidad</td>
                <td className="p-2">Saldo</td>
                <td className="p-2">Estado</td>
                <td className="p-2">Comprobante</td>
              </tr>
            </thead>
            <tbody className="text-cell ">
              {_.map([{}, {}, {}, {}], (theUser, index) => (
                <tr
                  onClick={() => {}}
                  className={`border-b border-white text-sm ${
                    index % 2 === 0 ? "bg-white" : "bg-header"
                  }`}
                  key={theUser.id}
                >
                  <td className="p-2 text-primary">{theUser.id}</td>
                  <td className="p-2 text-black-50"></td>
                  <td className="p-2 text-black-50"></td>
                  <td className="p-2 text-black-50"></td>
                  <td className="p-2 text-black-50"></td>
                  <td className="p-2 text-black-50"></td>
                  <td className="p-2 text-black-50">
                    <Download size={20} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div> */}

        <div className="flex justify-center w-full mt-4 mb-4">
          <Pagination meta={[]} onPageSelected={() => {}} />
        </div>
      </div>
    </div>
  );
};

export default UserDocuments;
